import { SITE_URL } from 'src/config/config'

export const useDefaultLogo = (logo?: string | null) => {
  return logo || `${SITE_URL}/vendor-logo.svg`
}
